export function heroVideo() {
    const heroSection = $(".hero-section .hero-bg");
    const video = heroSection.find("video");
    let windowWidth;

    function videoActions() {
        windowWidth = $(window).width();
        if (video) {
            const videoSource = video.find('source');

            if (windowWidth > 1023 && !video.hasClass('src-desktop')) {
                videoSource.attr('src', videoSource.data('src-desktop'));
                video.addClass('src-desktop').removeClass('src-tablet src-mobile');
                playVideo(video[0]);
            } else if (windowWidth > 739 && windowWidth < 1024 && !video.hasClass('src-tablet')) {
                videoSource.attr('src', videoSource.data('src-tablet'));
                video.addClass('src-tablet').removeClass('src-desktop src-mobile');
                playVideo(video[0]);
            } else if (windowWidth < 740 && !video.hasClass('src-mobile')) {
                videoSource.attr('src', videoSource.data('src-mobile'));
                video.addClass('src-mobile').removeClass('src-desktop src-tablet');
                playVideo(video[0]);
            }
        }
    }

    function playVideo(video) {
        video.load();
        video.play();
    }

    videoActions();
    $(window).on('resize', videoActions);
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroVideo.js